module.exports = __webpack_public_path__ + "img/integral-dialog-bg.394653c5.png";